var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ckeditor',{attrs:{"config":_vm.ck.config},on:{"input":function($event){return _vm.$emit('update:template', _vm.templateText)}},model:{value:(_vm.templateText),callback:function ($$v) {_vm.templateText=$$v},expression:"templateText"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ac8a203","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Template/TemplateEditor.vue
// module id = null
// module chunks = 